module.exports = __webpack_public_path__ + "static/hero-images-54248aee3ab8406eb56bfd9ff5b29f4e.png";